import { Vue, Component } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BButton, BForm, BFormInput, BFormGroup, BCard, BLink } from "bootstrap-vue";
import { BCardTitle, BCardText, BFormCheckbox, BTooltip } from "bootstrap-vue";
import { BInputGroup, BInputGroupPrepend, BInputGroupAppend } from "bootstrap-vue";
import { IAuthLoginDto, IAuthLoginResultDto, Social } from "@lib";
import AltLogo from "@/core/components/alt-logo";
import AltIcon from "@/core/components/alt-icon";
import { SocialAction } from "../socials";

@Component({
    components: {
        BCard,
        BCardTitle,
        BLink,
        BCardText,
        BButton,
        BFormCheckbox,
        BForm,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BInputGroupPrepend,
        BInputGroupAppend,
        BTooltip,
        ValidationProvider,
        ValidationObserver,
        AltLogo,
        AltIcon,
    },
})
export default class Login extends Vue {
    private resources = {
        LabelTitleText: "ВХОД",
        LabelSubtitle1Text: "Приветствуем!",
        LabelSubtitle2Text: "Пожалуйста, войдите в аккаунт:",
        TextBoxEmailLabel: "Почта",
        TextBoxPasswordLabel: "Пароль",
        LinkForgotText: "Забыли пароль?",
        LinkRegistrationText: "Регистрация",
        ButtonText: "Вход",
        ValidatorId: "loginForm",
    };

    private email: string = "";
    private password: string = "";
    private passwordVisible: boolean = false;

    public get socialsVisible(): boolean {
        return this.$alt.config.common.socialsEnabled;
    }

    private togglePasswordVisibility(): void {
        this.passwordVisible = !this.passwordVisible;
    }

    private async login(): Promise<void> {
        try {
            const valid = await (this.$refs[this.resources.ValidatorId] as any).validate();
            if (!valid) {
                return;
            }

            this.$alt.loader.show();

            const dto: IAuthLoginDto = {
                email: this.email,
                password: this.password,
            };

            const usecase = this.$alt.system.usecase.createAuthCompanyUseCase();
            const result = await usecase.login(dto);

            if (result.data.company) {
                // company token
                this.applyCompanyData(result);
                // const navigate = (this.$router.currentRoute.query.to as string) ?? "/home";
                // await this.$router.push(navigate);

                // await this.$router.push({ name: "orders", query: { notification: "1" } });
                await this.$router.push({ name: "orders" });
            } else {
                // user-only token
                this.applyUserOnlyData(result);
                await this.$router.push({ name: "switch-company" });
            }
        } catch (e: any) {
            this.$alt.toast.error(e.message);
        } finally {
            this.$alt.loader.hide();
        }
    }

    private async applyCompanyData(result: IAuthLoginResultDto): Promise<void> {
        this.$alt.removeFromLocalStorage("companyType");
        this.$alt.removeFromLocalStorage("partner");
        this.$alt.removeFromLocalStorage("meta");

        this.$alt.system.token.cleanData();
        this.$alt.system.token.setCompanyToken(result.accessToken);

        this.$info.setAuthInfo(result.data);
        this.$settings.setUserInfo(result.data.user.user.id);
        if (result.data.company) {
            this.$secure.grant(result.data.company.permissions);
        }
    }

    private async applyUserOnlyData(result: IAuthLoginResultDto): Promise<void> {
        this.$alt.removeFromLocalStorage("companyType");
        this.$alt.removeFromLocalStorage("partner");
        this.$alt.removeFromLocalStorage("meta");

        this.$alt.system.token.cleanData();
        this.$alt.system.token.setUserOnlyToken(result.accessToken);

        this.$info.setAuthInfo(result.data);
        this.$settings.setUserInfo(result.data.user.user.id);
    }

    public async authorizeWithYandex(): Promise<void> {
        return this.authorizeWithSocial(Social.Yandex);
    }

    public async authorizeWithVK(): Promise<void> {
        return this.authorizeWithSocial(Social.VK);
    }

    public async authorizeWithOK(): Promise<void> {
        return this.authorizeWithSocial(Social.OK);
    }

    public async authorizeWithGoogle(): Promise<void> {
        return this.authorizeWithSocial(Social.Google);
    }

    private async authorizeWithSocial(social: Social): Promise<void> {
        try {
            this.$alt.loader.show();

            const socialUri = this.$router.resolve({
                name: "socials",
                params: { action: SocialAction.Login, social },
            }).href;
            const redirectUri = `${window.location.origin}${socialUri}`;

            const usecase = this.$alt.system.usecase.createAuthSocialsUseCase();
            const uri = await usecase.getAuthorizationUri(social, redirectUri);

            if (uri && uri.length > 0) {
                window.location = uri as any;
            }
        } catch (e: any) {
            this.$alt.toast.error(e.message);
        } finally {
            this.$alt.loader.hide();
        }
    }
}
